module.exports = __webpack_public_path__ + "static/media/AMA Logo.bab5cc56.jpeg";